<template>
    <div class="joy-core-radius-3 joy-bgcolor-secondary-10" style="padding: 20px">
        <p class="joy-font-primary-350">{{ $t('profile.vetting.drawer.tab.profile.notes.add.disclaimer.title') }}</p>
        <p class="joy-font-primary-200">
            {{ $t('profile.vetting.drawer.tab.profile.notes.add.disclaimer.content') }}
            <VJoyLink href="/about/privacy/policy">{{ $t('profile.vetting.drawer.tab.profile.notes.add.disclaimer.link') }}</VJoyLink>
        </p>
        <div class="justify-right">
            <VJoyButton size="xsmall" @click="emits('accept')">
                {{ $t('profile.vetting.drawer.tab.profile.notes.add.disclaimer.cta') }}
            </VJoyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {VJoyButton, VJoyLink} from '@maltjoy/core-vue';

    const emits = defineEmits<{
        (e: 'accept'): void;
    }>();
</script>
